import get from 'lodash/get';
import React, { useState } from 'react';
import { obfuscatedCoordinates } from '../../util/maps';
import { types as sdkTypes } from '../../util/sdkLoader';
import Map from '../Map/Map';
import classNames from 'classnames';
import css from './TransactionPanel.css';

const { LatLng } = sdkTypes;

const ListingMap = ({ listing, className, showAddress }) => {
  const [isStatic, setStatic] = useState(true);
  const address = get(listing, 'attributes.publicData.location.address', '');
  const geolocation = get(listing, 'attributes.geolocation', { lat: 0, lng: 0 });
  const { lat, lng } = geolocation;
  const cacheKey = listing.id ? `${listing.id.uuid}_${lat}_${lng}` : null;
  const hideAddress = !showAddress;

  const mapProps = !showAddress
    ? {
        obfuscatedCenter: obfuscatedCoordinates({ lat, lng }, cacheKey),
        hideAddress,
      }
    : {
        address,
        center: new LatLng(lat, lng),
        hideAddress,
      };
  const map = <Map {...mapProps} useStaticMap={isStatic} hideAddress={hideAddress}/>;
  return (
    <div>
      {isStatic ? (
        <button
          className={classNames(css.map, className)}
          onClick={() => {
            setStatic(false);
          }}
        >
          {map}
        </button>
      ) : (
        <div className={classNames(css.map, className)}>{map}</div>
      )}
    </div>
  );
};

export default ListingMap;
